var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartBox"},[_c('v-chart',{ref:"chart",staticStyle:{"width":"100%"},attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }